// GENERATED by store-ksp from @StoreProvider. DO NOT EDIT — this is a build
// artifact, not committed source. Change the annotation on the provider instead.

package kpt.core.store.di

import kpt.core.base.store.infra.StoreCacheManager
import kpt.core.base.store.infra.impl.StoreCacheManagerImpl
import kpt.core.store.alerts.impl.provideAlertsStore
import kpt.core.store.alerts.impl.provideAlertsWriteStore
import kpt.core.store.banking.impl.provideBillRemindersStore
import kpt.core.store.banking.impl.provideBillRemindersWriteStore
import kpt.core.store.banking.impl.provideLoansStore
import kpt.core.store.banking.impl.provideLoansWriteStore
import kpt.core.store.calc.impl.provideAmortizationCalcStore
import kpt.core.store.cloudtodo.impl.provideCloudTodoReadStore
import kpt.core.store.cloudtodo.impl.provideCloudTodoStore
import kpt.core.store.config.AppStoreRegistry
import kpt.core.store.crypto.impl.provideCoinDetailStore
import kpt.core.store.crypto.impl.provideCoinMarketsStore
import kpt.core.store.currency.impl.provideExchangeRatesStore
import kpt.core.store.currency.impl.provideRateHistoryStore
import kpt.core.store.economic.impl.provideInterestRateSeriesStore
import kpt.core.store.economic.impl.provideMacroIndicatorStore
import kpt.core.store.emi.impl.provideEmiStore
import kpt.core.store.exchange.impl.provideSpotRateLookupStore
import kpt.core.store.prefs.impl.provideUserDataStore
import kpt.core.store.profile.impl.provideProfileStore
import kpt.core.store.watchlist.impl.provideWatchlistStore
import kpt.core.store.watchlist.impl.provideWatchlistWriteStore
import org.koin.core.module.Module
import org.koin.dsl.module

/**
 * Every `@StoreProvider`: its Koin binding AND its logout purge, from one annotation.
 *
 * `*Mutable` stores declare `logout = false` — Store5 5.1's MutableStore is not a `Store`
 * subtype so `register` cannot take one. Their rows still go: each shares a table with its
 * read store, whose deleteAll wipes it.
 *
 * Pulled in by `StoreModule` via `includes(GeneratedStoreBindings)`.
 */
val GeneratedStoreBindings: Module = module {
    single(AppStoreRegistry.Alerts) { provideAlertsStore(dao = get()) }
    single(AppStoreRegistry.AlertsMutable) { provideAlertsWriteStore(dao = get()) }
    single(AppStoreRegistry.AmortizationCalc) { provideAmortizationCalcStore(compute = get()) }
    single(AppStoreRegistry.BillReminders) { provideBillRemindersStore(dao = get()) }
    single(AppStoreRegistry.BillRemindersMutable) { provideBillRemindersWriteStore(dao = get()) }
    single(AppStoreRegistry.CloudTodo) { provideCloudTodoReadStore(api = get(), dao = get()) }
    single(AppStoreRegistry.CloudTodoMutable) { provideCloudTodoStore(api = get(), dao = get(), bookkeeper = get()) }
    single(AppStoreRegistry.CoinDetail) { provideCoinDetailStore(api = get(), networkMonitor = get(), dao = get()) }
    single(AppStoreRegistry.CoinMarkets) { provideCoinMarketsStore(api = get(), networkMonitor = get(), dao = get()) }
    single(AppStoreRegistry.Emi) { provideEmiStore(compute = get()) }
    single(AppStoreRegistry.ExchangeRates) { provideExchangeRatesStore(api = get(), networkMonitor = get(), dao = get()) }
    single(AppStoreRegistry.InterestRateSeries) { provideInterestRateSeriesStore(api = get(), config = get(), networkMonitor = get(), dao = get()) }
    single(AppStoreRegistry.Loans) { provideLoansStore(dao = get()) }
    single(AppStoreRegistry.LoansMutable) { provideLoansWriteStore(dao = get()) }
    single(AppStoreRegistry.MacroIndicator) { provideMacroIndicatorStore(api = get(), networkMonitor = get()) }
    single(AppStoreRegistry.Profile) { provideProfileStore(source = get()) }
    single(AppStoreRegistry.RateHistory) { provideRateHistoryStore(api = get(), networkMonitor = get(), dao = get()) }
    single(AppStoreRegistry.SpotRate) { provideSpotRateLookupStore(api = get(), networkMonitor = get(), dao = get()) }
    single(AppStoreRegistry.UserData) { provideUserDataStore(source = get()) }
    single(AppStoreRegistry.Watchlist) { provideWatchlistStore(dao = get()) }
    single(AppStoreRegistry.WatchlistMutable) { provideWatchlistWriteStore(dao = get()) }

    single(createdAtStart = true) {
        val mgr = get<StoreCacheManager>() as StoreCacheManagerImpl
        mgr.register(get(AppStoreRegistry.Alerts))
        mgr.register(get(AppStoreRegistry.AmortizationCalc))
        mgr.register(get(AppStoreRegistry.BillReminders))
        mgr.register(get(AppStoreRegistry.CloudTodo))
        mgr.register(get(AppStoreRegistry.CoinDetail))
        mgr.register(get(AppStoreRegistry.CoinMarkets))
        mgr.register(get(AppStoreRegistry.Emi))
        mgr.register(get(AppStoreRegistry.ExchangeRates))
        mgr.register(get(AppStoreRegistry.InterestRateSeries))
        mgr.register(get(AppStoreRegistry.Loans))
        mgr.register(get(AppStoreRegistry.MacroIndicator))
        mgr.register(get(AppStoreRegistry.Profile))
        mgr.register(get(AppStoreRegistry.RateHistory))
        mgr.register(get(AppStoreRegistry.SpotRate))
        mgr.register(get(AppStoreRegistry.UserData))
        mgr.register(get(AppStoreRegistry.Watchlist))
    }
}
